import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ColorIndicator } from '../../color-indicator';
import { getIcon } from '../../icon';
import { styled } from '../../styled';
import { TextField } from '../../textfield';
import { measureText, sentence, Typography } from '../../typography';
const StartAdornmentColorIndicator = styled(ColorIndicator)(({ theme }) => ({
    marginLeft: theme.spacing(0.75)
}));
export function renderInput(params, props, additionalProps) {
    const { state, setState, shrink } = additionalProps ?? {};
    const theme = additionalProps?.theme;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value = props.value;
    const isEmpty = !value || (Array.isArray(value) && !value.length);
    const onMouseDown = () => {
        if (props.disableSearch &&
            state === 'open' &&
            value !== null &&
            value !== undefined) {
            setState?.('blocked');
        }
    };
    if (props.renderInput) {
        return props.renderInput({
            ...params,
            slotProps: {
                ...params.slotProps,
                input: { ...params.slotProps?.input, onMouseDown }
            }
        });
    }
    const counter = (() => {
        const show = props.multiple &&
            !isEmpty &&
            Boolean(props.multipleConfig?.showCounter);
        const text = show && Array.isArray(value)
            ? `(${value.length}/${props.options.length})`
            : '';
        return {
            show,
            text,
            width: show && theme ? measureText(theme, text, 'detail') : 0
        };
    })();
    const startAdornment = (() => {
        let internalStartAdornment;
        if (!props.multiple &&
            value !== undefined &&
            value !== null &&
            (props.getOptionColor || props.getOptionIcon)) {
            if (props.getOptionColor) {
                internalStartAdornment = (_jsx(StartAdornmentColorIndicator, { color: props.getOptionColor(value) }));
            }
            if (props.getOptionIcon) {
                const { icon, iconProps = {} } = props.getOptionIcon(value);
                const Icon = getIcon(icon);
                internalStartAdornment = (_jsx(Icon, { ...iconProps, sx: { ml: 0.75, ...iconProps.sx } }));
            }
        }
        if (params.slotProps?.input?.startAdornment || internalStartAdornment) {
            return (_jsxs(_Fragment, { children: [params.slotProps?.input?.startAdornment, internalStartAdornment] }));
        }
        return undefined;
    })();
    const endAdornment = (() => {
        if (!counter.show) {
            return params.slotProps?.input?.endAdornment;
        }
        return (_jsxs(_Fragment, { children: [_jsx(Typography, { "data-role": "counter", color: "text.secondary", sx: {
                        '.MuiInputBase-root.Mui-focused &, .MuiInputBase-root:hover &': { display: 'block' },
                        display: 'none',
                        pointerEvents: 'none',
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        right: props.disableClearable ? 32 : 64
                    }, variant: "detail", children: counter.text }), params.slotProps?.input?.endAdornment] }));
    })();
    const textfieldSlotProps = {
        inputLabel: {
            ...params.slotProps.inputLabel,
            shrink,
            sx: {
                ...(shrink ? { transition: 'none' } : {}),
                maxWidth: 'calc(100% - 52px)'
            }
        },
        input: {
            ...params.slotProps.input,
            startAdornment,
            endAdornment,
            ...props.slotProps?.input
        },
        htmlInput: params.slotProps.htmlInput
    };
    const paddingRight = props.disableClearable ? 39 : 65;
    return (_jsx(TextField, { ...params, slotProps: textfieldSlotProps, inputRef: props.inputRef, bgColor: props.bgColor, loading: props.loading, skeleton: props.skeleton, readOnly: props.disableSearch, required: props.required, autoFocus: props.autoFocus, placeholder: isEmpty ? sentence(props.placeholder) : undefined, label: props.label, helperText: props.helperText, error: props.error, onMouseDown: onMouseDown, sx: {
            '& .MuiInputBase-root.MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
                paddingRight: `calc(${paddingRight}px + ${counter.width}px)`
            }
        } }));
}
export default { renderInput };
